import { Box, Skeleton, Stack } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

import { OrganismFrame } from '@/core/architecture'

export const ExhibitionContentSkeleton: FC = () => (
  <OrganismFrame>
    <SkeletonText variant="medium" width="25%" />
    <Box sx={{ py: 4 }}>
      <SkeletonText variant="small" numberOfLine={5} />
    </Box>
    <Skeleton variant="rectangular" height={1} />
    <Stack sx={{ pt: 5, pb: 8 }} spacing={6}>
      <Box>
        <SkeletonText variant="small" numberOfLine={2} />
      </Box>
      <Box>
        <SkeletonText variant="small" numberOfLine={2} />
      </Box>
      <Box>
        <SkeletonText variant="small" numberOfLine={2} />
      </Box>
    </Stack>
  </OrganismFrame>
)
